export const rationaleOptions = [
  { key: 'SUSPICIOUS_ACTIVITY', value: 'SUSPICIOUS_ACTIVITY', label: 'Suspicious Activity' },
  { key: 'UNUSUAL_TRANSACTION', value: 'UNUSUAL_TRANSACTION', label: 'Unusual Transaction Pattern' },
  { key: 'INITIAL_DUE_DILIGENCE', value: 'INITIAL_DUE_DILIGENCE', label: 'Initial Due Diligence (CDD)' },
  { key: 'ONGOING_DUE_DILIGENCE', value: 'ONGOING_DUE_DILIGENCE', label: 'Ongoing Due Diligence (ODD)' },
  { key: 'ENHANCED_DUE_DILIGENCE', value: 'ENHANCED_DUE_DILIGENCE', label: 'Enhanced Due Diligence (EDD)' },
  { key: 'CUSTOMER_REQUEST', value: 'CUSTOMER_REQUEST', label: 'Customer Request' },
  { key: 'INTERNAL_INVESTIGATION', value: 'INTERNAL_INVESTIGATION', label: 'Internal Investigation' },
  { key: 'REGULATORY_REQUIREMENT', value: 'REGULATORY_REQUIREMENT', label: 'Regulatory Requirement' },
  { key: 'OTHER', value: 'OTHER', label: 'Other' },
];

export const getRationaleLabel = (rationale: string): string => {
  return rationaleOptions.find((option) => option.value === rationale)?.label || rationale;
};
